import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import DescriptionNavigation from "../Description-Navigation";

import "./index.css";

export default function HamburgerMenu(props) {
  const { t } = useTranslation("translation");
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  // Early return if required props are not available
  if (!props.sceneData || !props.sceneData.Scrolly) {
    return null;
  }

  const toggleMenu = (e) => {
    const keycode = e.keyCode ? e.keyCode : e.which;
    if (keycode === 13 || e.type === "click") {
      setIsOpen(!isOpen);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        setIsOpen(false);
        buttonRef.current?.focus();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  return (
    <div className="hamburger-menu-container">
      <button
        ref={buttonRef}
        className="hamburger-toggle"
        aria-label={t("toggleNavigation.string") || "Toggle navigation menu"}
        aria-expanded={isOpen}
        aria-controls="hamburger-menu-panel"
        onClick={toggleMenu}
        onKeyUp={toggleMenu}
        tabIndex={0}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M3 12H21M3 6H21M3 18H21"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <nav
          ref={menuRef}
          id="hamburger-menu-panel"
          className="hamburger-menu-panel"
          role="navigation"
          aria-label={t("mainNavigation.string") || "Main navigation"}
        >
          <DescriptionNavigation
            sceneData={props.sceneData}
            percentage={props.percentage}
            forceAnimationTo={props.forceAnimationTo}
            forceScroll={props.forceScroll}
            descriptionID={props.descriptionID}
            totalTime={props.totalTime}
            bp={props.bp}
          />
        </nav>
      )}
    </div>
  );
}
